export function initHeader() {
    const header = document.querySelector(".siteHeader")
    if (header) {
        setupHeader(header)
    }
}

function setupHeader(header) {
    const mobileMenu = header.querySelector('.menu-mobile'),
        menu = header.querySelector('.menu')

    window.addEventListener('scroll', () => {
        window.pageYOffset > 50 ? header.classList.add('sticky') : header.classList.remove('sticky')
    })

    mobileMenu.addEventListener('click', toogleMenu)

    function toogleMenu() {
        mobileMenu.classList.toggle('open')
        menu.classList.toggle('open')
    }
}
